import { Row } from "@tanstack/react-table";
import clsx from "clsx";
import { useState } from "react";
import Cell from "./cells/cell";
import { twMerge } from "tailwind-merge";

export default function TableRow<RowType>(
  props: Row<RowType> & {
    className?: string;
    onRowClick?: (row: RowType) => void;
    enableRowClick?: boolean | ((row: RowType) => boolean);
  }
) {
  const {
    className,
    getCanExpand,
    getCanSelect,
    getCanMultiSelect,
    getIsSelected,
    getIsExpanded,
    getVisibleCells,
    toggleExpanded,
    toggleSelected,
    enableRowClick = false,
    onRowClick,
  } = props;

  const [hover, setHover] = useState(false);
  const enableClick =
    typeof enableRowClick === "function"
      ? enableRowClick(props.original)
      : enableRowClick;

  return (
    <tr
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={twMerge(
        clsx({
          "cursor-pointer select-none":
            getCanExpand() ||
            getCanSelect() ||
            getCanMultiSelect() ||
            enableClick,
          "bg-primary/25": getIsSelected() && hover,
          "bg-primary/10": getIsSelected() && !hover,
          "bg-gunmetal-50":
            !(getIsSelected() || getIsExpanded()) &&
            (getCanSelect() || getCanExpand() || enableRowClick) &&
            hover,
          "odd:bg-gunmetal-50/25":
            !getIsSelected() &&
            !getIsExpanded() &&
            !(hover && (getCanExpand() || getCanSelect() || enableRowClick)) &&
            props.getAllCells().at(0)?.getContext().table.options.meta?.striped,
        }),
        className
      )}
      onClick={() => {
        if (enableClick) onRowClick?.(props.original);
        else if (getCanExpand()) toggleExpanded();
        else if (getCanSelect()) toggleSelected();
      }}
    >
      {getVisibleCells().map((cell) => (
        <Cell {...cell} key={cell.id} />
      ))}
    </tr>
  );
}
